module.exports = require('../../full/object/freeze');
